import React from 'react';
import { TableCellsIcon } from '@heroicons/react/24/outline';

interface SyncTargetBannerProps {
  spreadsheetName: string;
  spreadsheetId: string;
  tabName: string;
}

const SyncTargetBanner: React.FC<SyncTargetBannerProps> = ({ spreadsheetName, spreadsheetId, tabName }) => (
  <div className="flex items-center gap-3 px-4 py-3 rounded-lg border border-blue-100 dark:border-blue-800 bg-blue-50 dark:bg-blue-900/20">
    <TableCellsIcon className="w-5 h-5 text-blue-500 flex-shrink-0" />
    <div className="min-w-0">
      <p className="text-sm font-semibold text-blue-800 dark:text-blue-200">
        {spreadsheetName} — <span className="font-bold">{tabName}</span> tab
      </p>
      <p className="text-xs text-blue-600 dark:text-blue-400 mt-0.5 font-mono truncate">
        {spreadsheetId}
      </p>
    </div>
  </div>
);

export default SyncTargetBanner;
